import React from 'react';
import SubHeading from '../../common/SubHeading';
import RadioRatingGroup from '../../common/RadioRatingGroup';
import { IntakeFormData } from '../../../lib/types/IntakeFormTypes';

interface SymptomQuestion {
  key: string;
  label: string;
}

interface SymptomGroupProps {
  title: string;
  questions: SymptomQuestion[];
  sectionKey: string;
  data: IntakeFormData['symptomAssessment'];
  handleChange: (path: string, value: unknown) => void;
  notes?: boolean;
  disabled?: boolean;
}

const ratingOptions = [
    { label: '0 - Never', value: '0' },
    { label: '1 - Rarely', value: '1' },
    { label: '2 - Moderate', value: '2' },
    { label: '3 - Severe', value: '3' },
];

const SymptomGroup: React.FC<SymptomGroupProps> = ({ title, questions, sectionKey, data, handleChange, notes = false, disabled }) => {
    const handleNoteChange = (symptomKey: string, value: string) => {
        const path = `symptomAssessment.${sectionKey}.${symptomKey}_note`;
        handleChange(path, value);
    };

    return (
    <div>
        <SubHeading>{title}</SubHeading>
        {questions.map((q) => (
             <div key={q.key} className="grid grid-cols-1 md:grid-cols-2 gap-4 border-b border-gray-100 py-2">
                <RadioRatingGroup 
                    label={q.label}
                    name={`symptomAssessment.${sectionKey}.${q.key}`}
                    value={(data[sectionKey] as Record<string, string>)?.[q.key] || ''}
                    options={ratingOptions}
                    onChange={(_name, val) => handleChange(`symptomAssessment.${sectionKey}.${q.key}`, val)}
                    disabled={disabled}
                />
                {notes && (
                    <div>
                         <label htmlFor={`${q.key}_note`} className="block text-brand-stone-700 mb-2 font-medium">Notes</label>
                        <input
                            id={`${q.key}_note`}
                            type="text"
                            value={(data[sectionKey] as Record<string, string>)?.[`${q.key}_note`] || ''}
                            onChange={(e) => handleNoteChange(q.key, e.target.value)}
                            className="w-full px-4 py-2 border border-brand-stone-300 rounded-md focus:ring-2 focus:ring-brand-green-500 bg-white"
                            disabled={disabled}
                        />
                    </div>
                )}
            </div>
        ))}
    </div>
    )
};

export default SymptomGroup;